var React = require('react');

function Locked (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.3","cx":"40","cy":"40","r":"40","fill":"#FFD37B","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M46 36H44.9286V33.7143C44.9286 30.56 42.5286 28 39.5714 28C36.6143 28 34.2143 30.56 34.2143 33.7143V36H33.1429C31.9643 36 31 37.0286 31 38.2857V49.7143C31 50.9714 31.9643 52 33.1429 52H46C47.1786 52 48.1429 50.9714 48.1429 49.7143V38.2857C48.1429 37.0286 47.1786 36 46 36ZM42.8929 35.9982H36.25V33.7125C36.25 31.7582 37.7393 30.1696 39.5714 30.1696C41.4036 30.1696 42.8929 31.7582 42.8929 33.7125V35.9982Z","fill":"#F6A400","key":1})]);
}

Locked.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Locked;

Locked.default = Locked;
